export default "__VITE_ASSET__d9241163__"